import defaultTheme from '@ntuctech/devex-tangram/Theme/defaultTheme'
import styled from 'styled-components'
import { SCREEN_SIZE } from '../../lib/Media'

const styles = {}

styles.PromotionSection = styled.section`
  margin-bottom: 1.5rem;
  width: 100%;
  ${SCREEN_SIZE.From.Desktop} {
    width: calc(100% - 1.5rem);
  }
`

styles.StyledPromotions = styled.div`
  a {
    text-decoration: none;

    background-color: white;
    color: #1557bf;

    display: block;
    margin-right: 0.5rem;
    padding: 0.5rem 1rem;

    border-radius: 4px;
    border-color: #eaeaea;
  }

  li {
    display: inline-block;
    white-space: normal;
    vertical-align: top;
  }
`

styles.Tag = styled.button`
  text-decoration: none;
  background-color: white;
  color: ${defaultTheme.ColorBaseBrandPrimary500};
  display: block;
  margin-right: 0.5rem;
  padding: 0.5rem 1rem;
  border: 1px solid ${defaultTheme.ColorBaseMineShaft80};
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  width: 100%;
  &:active {
    border-style: solid;
    border-radius: 4px;
    border-color: ${defaultTheme.ColorBaseMineShaft80};
  }
  ${props =>
    props.isActive
      ? `
    background-color: ${defaultTheme.ColorBaseBrandPrimary500};
    color: white;
    border: none;
  `
      : ``}
`

export default styles
